import { useState, useEffect } from "react";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from "../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {
    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/banking-histories/save`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllBankAccounts: `${endpointBackend}gci/bank-accounts/getall`,
        endpointVerifyBankAccountFromFile: `${endpointBackend}gci/banking-histories/verifyBankAccountFromFile`,
        urlGoBack: '/gci/banking-histories/competencies',
        pathView: '/gci/banking-histories/view'
    }

    const labels = {
        labelTitleAdd: "Importar Extrato",
        labelTitleEdit: "",
        labelTitleView: ""
    }

    const getForm = (values) => {
        let form = {
            hiddenValues,
            validateOnChange: true,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_bank_account_id = null;
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'gci_bank_account_id',
                    type: 'select',
                    label: 'Conta Bancária',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBankAccounts,
                        label: 'full_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: values.gci_company_id
                            }
                        }
                    },
                    validations: {
                        required: true,
                        verifyBankAccountFromFile: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'file',
                    type: 'file',
                    label: 'Arquivo OFX',
                    extensionAccept: '.ofx',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                verifyBankAccountFromFile: async (value, options, key, attributes) => {
                    if (attributes.file && attributes.gci_bank_account_id) {
                        const verify = await Fetch.post(paths.endpointVerifyBankAccountFromFile, { ...attributes })
                        if (!verify.success) {
                            if (verify.fileError) {
                                return '^ Verifique a estrutura do arquivo e tente novamente.'
                            } else {
                                return '^ Conta bancária não está correta de acordo com o arquivo.'
                            }
                        }
                    } else {
                        return '';
                    }
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            const form = getForm({});
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
